
const logosStyle = theme => ({

    
  });
  
  export default logosStyle;
  